import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LoadMFScriptService {
  public loading = new BehaviorSubject(false);

  constructor() {
  }

  loadScript(url: string) {
    this.loading.next(true);
    const head = document.getElementsByTagName('head')[0];
    const scrs = head.getElementsByTagName('script');

    for (let i = 0; i < scrs.length; i++) {
      const scr = scrs[i];

      if (scr.outerHTML.indexOf(url) > 0) {
        head.removeChild(scr);
      }
    }
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    head.appendChild(script);

    script.onload = (x) => {
      this.loading.next(false);
    };
  }
}
